<div class="header">
	<p class="path-details">
		<strong> {{ "syncActions.type" | translate }} </strong>
		<span>{{ "syncActions.file" | translate }}</span>
	</p>
	<p>
		<strong> {{ "syncActions.fileName" | translate }} </strong>
		<span>{{ cachedFile?.filename }}</span>
	</p>
</div>

<div class="body"></div>
